import React from 'react';
import OrderListTemplate from '../components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from '../components/OrderTriggerActionMap';
import { buildOrderInfoLines, useDefaultQueryFields } from '../order.effect';
import { useStaffMap } from '../../../services/store/organization.store';

import { Typography } from 'antd';
const { Text } = Typography;

const DoneDecisionList: React.FC = () => {
  const tabScene = OrderTabScene.GroupDecisionDone;
  const queryFields = useDefaultQueryFields(tabScene);
  const { staffMap } = useStaffMap();

  const renderInfo = (order: MergedOrder) => {
    const lines = buildOrderInfoLines(order, staffMap, ['preprocessOperator', 'auditOperator', 'auditConclusion', 'decisionConclusion', 'decisionTime']);
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 8 }}>
        {lines.map((line, idx) => (
          <Text key={idx} style={{ color: line.color || '#1677ff' }}>
            {line.label}: {line.value}
          </Text>
        ))}
      </div>
    );
  };

  const renderTableActions = (order: MergedOrder) => {
    const targets: OrderTriggerTarget[] = ['reportView', 'auditDetailView'];

    // 判断补充材料和预收凭证是否存在有效内容
    const supplementMaterials = order.audit?.supplementMaterials;
    const hasSupplementMaterials = supplementMaterials && (
      (Array.isArray(supplementMaterials) && supplementMaterials.length > 0) ||
      (!Array.isArray(supplementMaterials) && Object.keys(supplementMaterials).length > 0)
    );

    const prepayVoucher = order.audit?.prepayVoucher;
    const hasPrepayVoucher = Array.isArray(prepayVoucher) ? prepayVoucher.length > 0 : !!prepayVoucher;

    // "已决策订单" 的补充材料和预收凭证条件展示（使用统一的 action key，内部根据是否有结果判断展示"查看"或"提交"）
    if (hasSupplementMaterials || order.order.decisionStatus === 3) { // DecisionStatusSupplement = 3
      targets.push('supplementAction');
    }
    if (hasPrepayVoucher || order.order.decisionStatus === 5) { // DecisionStatusPreCollection = 5
      targets.push('prepayAction');
    }
    if (order.order.orderStatus === 30 || order.order.cancelType) {
      targets.push('cancelReasonView');
    }

    return <OrderTriggerActionMap layout="list" targets={targets} order={order} />;
  };

  return (
    <OrderTriggerActionProvider>
      <OrderListTemplate
        tabScene={tabScene}
        defaultScene="tab_decision_done"
        queryFields={queryFields}
        viewModes={[
          {
            mode: 'list',
            label: '产品页',
            renderActions: renderTableActions,
            renderInfo,
          },
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default DoneDecisionList;
